// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.fermentation_protocol_mode_enum */
var FermentationProtocolModeEnum;
(function (FermentationProtocolModeEnum) {
    FermentationProtocolModeEnum["BATCH"] = "BATCH";
    FermentationProtocolModeEnum["FED_BATCH"] = "FED_BATCH";
    FermentationProtocolModeEnum["CONTINUOUS"] = "CONTINUOUS";
})(FermentationProtocolModeEnum || (FermentationProtocolModeEnum = {}));
;
export default FermentationProtocolModeEnum;
/** Zod schema for fermentation_protocol_mode_enum */
export const fermentationProtocolModeEnum = z.nativeEnum(FermentationProtocolModeEnum);
//# sourceMappingURL=FermentationProtocolModeEnum.js.map